import { Breadcrumbs } from "ui/breadcrumbs";
import PageContent from "components/partials/page-content/page-content";

import { useCurrentClient } from "hooks/api/use-clients";

import { getClientPaths } from "utilities/app-routes";

const StudentRouterPage = () => {
  const client = useCurrentClient();
  const { clientCampaignsPath } = getClientPaths({ clientId: client?.id });

  return (
    <PageContent className="py-5">
      <Breadcrumbs
        sx={{ mb: 2 }}
        breadcrumbs={[
          { label: client?.name, href: clientCampaignsPath },
          { label: "Student router", active: true },
        ]}
      />
    </PageContent>
  );
};

export default StudentRouterPage;
